import { FreeCashFlowEntry } from 'types/evaluation';
import { parseMomentUtc } from 'utils/dates';

/**
 * The free-cash-flow entries within the [effectiveDate, effectiveDate + noOfYears)
 * window. Pure (uses no React), so it can be reused off the render path — e.g.
 * building the content-export cumulative footer from the same window the on-screen
 * table uses.
 *
 * @param {FreeCashFlowEntry[]} freeCashFlows - The unfiltered cashflow entries.
 * @param {string} effectiveDate - The evaluation effective date (UTC ISO).
 * @param {number} noOfYears - The window length in years.
 * @return {FreeCashFlowEntry[]} The entries inside the window.
 */
export const filterFreeCashflow = (
  freeCashFlows: FreeCashFlowEntry[],
  effectiveDate: string,
  noOfYears: number
): FreeCashFlowEntry[] => {
  const effectiveStart = parseMomentUtc(effectiveDate).clone();

  const isMidInterval = !effectiveStart.isSame(
    effectiveStart.clone().startOf('year')
  );

  const effectiveEnd = parseMomentUtc(effectiveDate)
    .clone()
    .startOf('year')
    .add(noOfYears + (isMidInterval ? 0 : -1), 'year')
    .endOf('year');

  return freeCashFlows.filter((cashflow) => {
    const cashflowDate = parseMomentUtc(cashflow.date);

    return (
      cashflowDate.isSameOrAfter(effectiveStart) &&
      cashflowDate.isSameOrBefore(effectiveEnd)
    );
  });
};
